import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NavigationLinks = ({
  header,
  links,
  onClickCb,
  onCollapse,
  isCollapsed,
  canCollapse,
}) => {
  const scrollRef = React.useRef();

  React.useEffect(() => {
    if (!isCollapsed && scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [isCollapsed]);

  return !!links.length ? (
    <nav
      className={`${
        canCollapse ? '' : 'h-auto'
      } transition-height ease-linear ${
        isCollapsed ? 'mb-2 h-10 overflow-hidden' : 'mb-4'
      }`}
      style={
        isCollapsed
          ? undefined
          : {
              height: links.length * 40 + 30 + 'px',
            }
      }
    >
      {!!links[0].to ? (
        <NavLink
          isActive={(match, location) => {
            return (
              match?.isExact ||
              links.some((item) => location.pathname === item.to)
            );
          }}
          onClick={onClickCb}
          to={links[0].to}
          className="nav-header"
        >
          {header}
        </NavLink>
      ) : (
        <div
          className={`flex items-center justify-between ${
            canCollapse ? ' cursor-pointer' : ''
          }`}
          onClick={onCollapse}
          data-testid="navbar-item"
          ref={scrollRef}
        >
          <h3 className="nav-header flex-auto flex-grow-0">{header}</h3>
          {canCollapse && (
            <span className="mr-2 w-6 text-center text-javelin-gray-dark">
              <FontAwesomeIcon
                icon={isCollapsed ? 'chevron-up' : 'chevron-down'}
                size="xs"
                className="text-javelin-gray-dark"
              />
            </span>
          )}
        </div>
      )}
      <div>
        {links.map((item) =>
          // having "to" key means is not an external url
          !!item.to ? (
            <NavLink
              key={item.name}
              onClick={onClickCb}
              to={item.to}
              className="nav-link"
            >
              {item.name}
            </NavLink>
          ) : (
            <a key={item.name} href={item.url} className="nav-link">
              {item.name}
            </a>
          )
        )}
      </div>
    </nav>
  ) : null;
};

NavigationLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({})),
  onClickCb: PropTypes.func,
  header: PropTypes.string,
  canCollapse: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  onCollapse: PropTypes.func,
};
NavigationLinks.defaultProps = {
  links: [],
  canCollapse: true,
  isCollapsed: false,
};

export default NavigationLinks;
